export default __webpack_public_path__ + "static/media/mobile_apiary_map_uk.04755794.png";